




























import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  onMounted,
  watch,
} from '@vue/composition-api';
import Form from '@/components/Form/index.vue';
import Pagination from '@/components/Pagination';
import addComma from '@/utils/addComma';
import request from '@utils/request';
import { userInfor as userInfoRef, isCore } from '@/useable/login';
const userInfor = userInfoRef.value;

export default defineComponent({
  name: 'billList',
  components: {
    Form,
    Pagination,
  },
  setup(props: any, { root }: any) {
    const tableConfig = ref({
      column: [
        { key: 'vendorName', label: '供应商名称', width: 210 },
        { key: 'socialCreditCode', label: '企业税号', width: 210 },
        { key: 'bankName', label: '申请融资银行', width: 130 },
        // { key: 'bankCode', label: '融资银行编码', width: 130 },
        { key: 'totalScore', label: '总评分', width: 120 },
        { key: 'cooperateYears', label: '合作年限', width: 120 },
        { key: 'cooperateYearsScore', label: '合作年限评分', width: 110 },
        // { key: 'cooperateYearsWeights', label: '合作年限指标权重', width: 110 },
        { key: 'cooperationScale', label: '合作规模', width: 210 },
        { key: 'cooperationScaleScore', label: '合作规模评分', width: 110 },
        { key: 'coopStability', label: '合作稳定性', width: 110 },
        { key: 'coopStabScore', label: '合作稳定性评分', width: 120 },
        { key: 'cashflow', label: '履约能力', width: 110 },
        { key: 'cashflowScore', label: '履约能力评分', width: 110 },
        { key: 'financePeriods', label: '账期DOP', width: 210 },
        { key: 'financePeriodsScore', label: '账期DOP评分', width: 110 },
        { key: 'bizStatus', label: '银行评估状态', width: 110 },
        { key: 'processMsg', label: '不通过原因', width: 110 },
        // { key: 'dataDate', label: '更新日期', width: 110 },
        // { key: 'processMsg', label: '处理消息', width: 110 },
        { key: 'processDate', label: '申请日期', width: 110 },
        // { key: 'id', label: '记录id', width: 110 },
        // { key: 'requestSeq', label: '请求编号', width: 110 },
        
      ],
      data: [],
    });
    const state = reactive({
      form: {
        vendorName: '',
        bankCode: '',
        totalScoreFollow: '',
        totalScoreTo: '',
      } as any,
      downloadUrl: 'dataFinancing-financeInterfaceExport',
      total: 0,
      pageSize: 10,
      page: 1,
      formBusinessColumn: [
        {
          name: 'vendorName',
          type: 'AsyncSelect',
          asyncName: 'parameter',
          label: '供应商名称：',
          placeholder: '输入供应商名称',
          url: 'dataFinancing-getVendorNameInfoSelect',
          options: [],
        },
        {
          name: 'bankCode',
          type: 'select',
          label: '融资银行：',
          placeholder: '请选择',
          options: [],
        },
        {
          name: 'totalScoreFollow',
          type: 'number',
          label: '总评分从：',
          placeholder: '请输入',
        },
        {
          name: 'totalScoreTo',
          type: 'number',
          label: '总评分至：',
          placeholder: '请输入',
        },
        {
          name: 'bizStatus',
          type: 'select',
          label: '评估状态：',
          placeholder: '请选择',
          options: [
            {
              name: '评估中',
              value: 'R',
            },
            {
              name: '评估成功',
              value: 'SUCCEED',
            },
            {
              name: '评估失败',
              value: 'FAILED',
            }
          ],
        },
        {
          name: 'processDate',
          type: 'daterange',
          label: '申请日期：',
          placeholder: '请选择日期',
        },
      ],
    });
    watch(()=> state.form.processDate, (newValue)=> {
      state.form.processDateFollow =
          (newValue &&
            newValue.length > 0 &&
            newValue[0]) ||
          '';
      state.form.processDateTo =
        (newValue &&
          newValue.length > 0 &&
          newValue[1]) ||
        '';
    });
    const getData = async () => {
      Promise.all([request('financing', 'bankList', {bankListFlag: 'dataFin'})]).then((result) => {
        if (result[0].code === 2000) {
          (
            (state.formBusinessColumn as any).find(i => i.name === 'bankCode') as any
          ).options = result[0].data.map(i => ({
            value: i.bankCode,
            name: i.bankName,
          }));
        }
      });
    };

    const getBillList = async () => {
      const params = {
        ...state.form,
        current: state.page,
        pageSize: state.pageSize,
      };
      delete params.processDate;
      const res = await request('dataFinancing', 'getInterfaceList', params);
      if (res.code === 2000) {
        tableConfig.value.data = res.data.dataList;
        state.total = res.data.total;
      }
    };
    const getSupplierInfoSelect = async (query) => {
      const parms = {
        parameter: query,
        current: 1,
        size: 10,
      };
      const res = await request('dataFinancing', 'getVendorNameInfoSelect', parms);
      if (res.code === 2000) {
        state.formBusinessColumn[0].options = res.data.map(i=>({value: i, name: i}));
      }
    };
    getSupplierInfoSelect('');
    getBillList();
    const submit = async () => {
      getBillList();
    };

    const pageChange = (newPage, newSize) => {
      state.page = newPage;
      state.pageSize = newSize;
      submit();
    };

    const onSearch = (val) => {
      state.form = val;
      state.page = 1;
      state.pageSize = 10;
      submit();
    };
    const checkDetail = (data) => {
      // root.$router.push({
      //   path: '/bill/detail',
      //   query: {
      //     orderNo: data
      //   }
      // });
      const routeUrl = root.$router.resolve(`/dataFinancing/detail/${data}`);
      window.open(routeUrl.href, '_blank');
    };
    onMounted(getData);
    return {
      ...toRefs(state),
      pageChange,
      onSearch,
      tableConfig,
      getBillList,
      checkDetail,
      getSupplierInfoSelect,
      addComma,
    };
  },
});
